//
//  DocumentationLegacyPage.ts
//  SDKSupernova
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { DocumentationLegacyItemType } from "../enums/SDKDocumentationLegacyItemType";
import { DocumentationLegacyBlockBuilder } from "./builder/SDKDocumentationLegacyBlockBuilder";
import { DocumentationLegacyItem, } from "./SDKDocumentationLegacyItem";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyPage extends DocumentationLegacyItem {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, customBlocks, configuration) {
        super(model);
        this.type = DocumentationLegacyItemType.page;
        if (model.blocks) {
            this.blocks = model.blocks
                .map((b) => DocumentationLegacyBlockBuilder.fromGenericModel(b, 
            // @ts-expect-error TS(2345): Argument of type 'ExporterCustomBlock[] | undefine... Remove this comment to see the full error message
            customBlocks, configuration))
                .filter((b) => b !== undefined && b !== null);
        }
        this.deployedUrl = null;
        this.relativeUrl = model.path;
        this.editorUrl = null;
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Convenience
    /** Internal: Modifies object with new paths. Don't use outside SDK environment as it doesn't propagate the data back to source */
    internalOverridePaths(deployed, editor) {
        this.editorUrl = editor;
        this.deployedUrl = deployed;
    }
    /** Internal: Sets new parent. Used when manipulating with object internally. Don't use outside SDK environment */
    setParent(parent) {
        this.parent = parent;
    }
    /** Retrieve editor page URL that can be opened */
    editorPageUrl() {
        return this.editorUrl;
    }
    /** Retrieve documentation page URL, if the documentation was already deployed (either default or custom domain) */
    deployedPageUrl() {
        return this.deployedUrl;
    }
    /** Retrieve relative page path without the associated domain. Will work even when documentation was not yet deployed */
    relativePageUrl() {
        return this.relativeUrl;
    }
}
